import { PURE } from '@travel-frontend/state-handling-sdk';
import { EMIT_SPLIT_CLIENT, EMIT_SPLIT_SDK_INIT, EMIT_SPLIT_SDK_INIT_TIMED_OUT, EMIT_SPLIT_SDK_INIT_USER_ID_FETCH, } from '../redux/actions.js';
const emitSplitClient = (action) => {
    return {
        event: 'split_initiated',
        split_client: action.client,
        split_manager: action.manager,
        metric_event_time: action.duration,
    };
};
const emitSplitSDKInitStarted = () => {
    return {
        event: 'split_initiation_started',
    };
};
const emitSplitSDKInitTimedOut = () => {
    return {
        event: 'split_initiation_timed_out',
    };
};
const emitSplitSDKInitUserIdFetch = (action) => {
    return {
        event: 'split_initiation_user_id_fetch',
        metric_event_time: action.duration,
    };
};
export const eventsMap = {
    [PURE(EMIT_SPLIT_CLIENT)]: emitSplitClient,
    [PURE(EMIT_SPLIT_SDK_INIT)]: emitSplitSDKInitStarted,
    [PURE(EMIT_SPLIT_SDK_INIT_TIMED_OUT)]: emitSplitSDKInitTimedOut,
    [PURE(EMIT_SPLIT_SDK_INIT_USER_ID_FETCH)]: emitSplitSDKInitUserIdFetch,
};
//# sourceMappingURL=gtm.js.map